// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"431055ae398a599e497a","597":"6e688f85f953cc5f306d","691":"2238454f28cf7f2df6f5","774":"023d14fa5e20482a2600","932":"6d8bbdd017a4a5f96e38"}[chunkId] + ".js";
};